__turbopack_context__.v({
  "avatarDot": "sJgfxG_avatarDot",
  "bar": "sJgfxG_bar",
  "barDesc": "sJgfxG_barDesc",
  "barDescShort": "sJgfxG_barDescShort",
  "barMeta": "sJgfxG_barMeta",
  "barMetaShort": "sJgfxG_barMetaShort",
  "barTitle": "sJgfxG_barTitle",
  "closeButton": "sJgfxG_closeButton",
  "content": "sJgfxG_content",
  "footer": "sJgfxG_footer",
  "list": "sJgfxG_list",
  "listItem": "sJgfxG_listItem",
  "lock": "sJgfxG_lock",
  "mainBtn": "sJgfxG_mainBtn",
  "modal": "sJgfxG_modal",
  "modalContent": "sJgfxG_modalContent",
  "primary": "sJgfxG_primary",
  "root": "sJgfxG_root",
  "secBtn": "sJgfxG_secBtn",
  "secondary": "sJgfxG_secondary",
  "sub": "sJgfxG_sub",
  "tabs": "sJgfxG_tabs",
});
